module.exports = __webpack_public_path__ + "Kooperativa.jpg?594522e7b7423a93985be01e56906f0c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/Kooperativa.jpg
// module id = 238
// module chunks = 0